import HallBookingsContainer from "../../container/admin/hall-bookings";

const HallBookings = () => {
    return <HallBookingsContainer />;
};

export default HallBookings;
